import { render } from "./CollectionDetailedSearchAudioVisualMaterials.vue?vue&type=template&id=e5e310f4&scoped=true&ts=true"
import script from "./CollectionDetailedSearchAudioVisualMaterials.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchAudioVisualMaterials.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchAudioVisualMaterials.vue?vue&type=style&index=0&id=e5e310f4&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5e310f4"]])

export default __exports__